import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import shopIcon from "../images/shop-icon.jpg";
import "./Header.css";
import ModalLogin from "./Login/ModalLogin";
import { useDispatch } from "react-redux";
import { logOut } from "../redux/reducer/Login";
import Swal from "sweetalert2";
import About from "./ModalHeader/About";
import Portfolio from "./ModalHeader/Portfolio";
const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let infoUser = JSON.parse(localStorage.getItem("userCredentials"));
  const out = () => {
    dispatch(logOut());
    Swal.fire({
      icon: "success",
      text: "Log out successfully",
    }).then((result) => {
      navigate("/");
    });
  };
  const handleScroll = () => {
    if (window.scrollY !== 0) {
      document.querySelector("header").classList.add("sticky");
    } else {
      document.querySelector("header").classList.remove("sticky");
    }
  };
  const active = () => {
    document.querySelector(".toogle").classList.toggle("active");
    document.querySelector("nav").classList.toggle("show");
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <header className="header">
        <img src={shopIcon} className="banner" alt="banner" />
        <p className="logo">ShopForYou</p>
        <div className="toogle" onClick={active}></div>
        <nav>
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="#" data-bs-toggle="modal" data-bs-target="#about">
                About Me
              </a>
            </li>
            <li>
              <a href="#" data-bs-toggle="modal" data-bs-target="#portfolio">
                Portfolio
              </a>
            </li>
            <li>
              {infoUser !== null ? (
                <button className="logout" onClick={out}>
                  Log Out
                </button>
              ) : (
                <button
                  className="login"
                  data-bs-toggle="modal"
                  data-bs-target="#login"
                >
                  Login
                </button>
              )}
            </li>
            <li>
              {infoUser !== null ? (
                infoUser.role === "admin" ? (
                  <Link to="/admin">
                    <button className="ml-2 btn btn-warning text-light">
                      Admin view
                    </button>
                  </Link>
                ) : (
                  <a className="ml-2">{infoUser.name}</a>
                )
              ) : (
                <a className="ml-2 text-light">Guest</a>
              )}
            </li>
          </ul>
        </nav>
      </header>
      <ModalLogin />
      <About />
      <Portfolio />
    </>
  );
};

export default Header;
